// removed by extract-text-webpack-plugin
module.exports = {"root":"Reviews__root__27TeD","reviewItem":"Reviews__reviewItem__2wgSK","reviewInfosContainer":"Reviews__reviewInfosContainer___f9Do","avatar":"Reviews__avatar__1Ex0w","reviewInfos":"Reviews__reviewInfos__3d6TF","authorDisplayName":"Reviews__authorDisplayName__1RyEf","reviewedAtAndRating":"Reviews__reviewedAtAndRating__h2SQU","reviewRating":"Reviews__reviewRating__1INEj","reviewRatingStar":"Reviews__reviewRatingStar__3fo-2","separator":"Reviews__separator__3F0Yr","reviewContainer":"Reviews__reviewContainer__3VQ1s","reviewContent":"Reviews__reviewContent__wx75Y","showMoreButton":"Reviews__showMoreButton__3dA-u"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Reviews/Reviews.css
// module id = 2076
// module chunks = 0